import Vue from 'vue'
import {
  SET_PAYMENT_METHODS_ORDER,
  SET_SELECTED_PAYMENT_METHOD,
  SET_SELECTED_PAYMENT_OPTION,
  SET_STORE_USER_CONFIRM_PAYMENT
} from './mutation-types'
import {
  SET_PAYMENT_ISSUER_NAME,
  SET_PAYMENT_METHOD_NAME
} from '../cart/mutation-types'

export default {
  updatePaymentMethods: async ({commit, rootState}) => {
    const token = rootState.user.token
    const paymentMethodsOrder = await Vue.prototype.$container.orderApiClient.getPaymentMethodsOrder(rootState.cart.order, token)
    commit(SET_PAYMENT_METHODS_ORDER, paymentMethodsOrder)
  },
  setSelectedPaymentMethod: ({commit}, paymentMethod) => {
    commit(SET_SELECTED_PAYMENT_METHOD, paymentMethod)
    commit(SET_SELECTED_PAYMENT_OPTION, null)
    if (paymentMethod != null) {
      commit('cart/' + SET_PAYMENT_METHOD_NAME, paymentMethod.title, { root: true })
    }
    commit('cart/' + SET_PAYMENT_ISSUER_NAME, null, { root: true })
  },
  setSelectedPaymentOption: ({commit}, paymentOption) => {
    commit(SET_SELECTED_PAYMENT_OPTION, paymentOption)
    if (paymentOption != null) {
      commit('cart/' + SET_PAYMENT_ISSUER_NAME, paymentOption.issuerName, {root: true})
    }
  },
  setStoreUserConfirmPayment: ({commit}, confirmed) => {
    commit(SET_STORE_USER_CONFIRM_PAYMENT, confirmed)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/actions.js